window.papaparse = require("papaparse");